export const locale = {
  lang: 'fr',
  data: {
    BITSO: {
      AWESOME: 'Créer génial 🙌',
      BITSO: 'Gestion des crypto-actifs sur Bitso',
      BITSO_ACCOUNT_DETAILS: 'Détails du compte',
      BITSO_CRYPTO_ASSETS: 'Actifs cryptographiques',
      BITSO_CRYPTO_QUOTES: 'Cours des Cryptos',
      BITSO_THE_PURCHASE_WAS_COMPLETED_SUCCESSFULLY: 'L\'achat a été effectué avec succès.',
      BITSO_SUCCESS: 'Succès',
      BITSO_ERROR: 'Erreur',
      BITSO_COMMUNICATION_ERROR: 'Erreur de communication',
      GET_BALANCE: 'Obtenir le solde',
      GET_QUOTE: 'Obtenir une cotation',
      CONFIRM_PURCHASE: 'Confirmer l\'achat',
      GET_CUSTOMER_INFORMATION: 'Obtenir les informations du client'
    }
  }
}
